import React, { useEffect, useState } from "react";
import Maincomponent from "../../Components/Maincomponent/Maincomponent";
import "./profile.css";
import { Modal, Button } from "react-bootstrap";
import mascot from "../../Images/mascot2.png";
import axios from "axios";
import Apiurl from "../../Apiurl";

export default function Profile() {
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const apiurl = Apiurl();
  const [userData, setuserdata] = useState({
    id: 1,
    Name: "",
    Role: "",
    Contact_number: "",
    Email: "",
    Status: "",
    Designation: " ",
    Staffid: "",
    usertype: "",
  });

  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handlePasswordChange = (e) => {
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
  };

  const handleClose = () => {
    setShowPasswordModal(false);
    setPasswordData({ oldPassword: "", newPassword: "", confirmPassword: "" });
  };

  const handleSavePassword = async () => {
    // Validation
    if (
      !passwordData.oldPassword ||
      !passwordData.newPassword ||
      !passwordData.confirmPassword
    ) {
      alert("Please fill all fields");
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      alert("New passwords do not match");
      return;
    }

    const payload = {
      username: localStorage.getItem("userid"), // send username
      old_password: passwordData.oldPassword,
      new_password: passwordData.newPassword,
    };

    try {
      const response = await axios.post(apiurl + "change-password/", payload);

      alert("Password updated successfully!");

      // Close modal
      setShowPasswordModal(false);

      // Reset form
      setPasswordData({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (error) {
      console.log(error);

      if (error.response) {
        alert(error.response.data?.errors || "Password update failed");
      } else {
        alert("Server error. Try again later.");
      }
    }
  };

  // const handleSavePassword = async () => {
  //   console.log("Password Change:", passwordData);
  //   setShowPasswordModal(false);
  // };
  useEffect(() => {
    const fetchUserData = async () => {
      const uid = window.localStorage.getItem("userid");
      try {
        const response = await axios.get(
          apiurl + `staffdetails/?Role=&Status=&Staffid=${uid}`
        );
        setuserdata(response.data[0]);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  return (
    <Maincomponent tabname={"Profile"}>
      <div className="component-sub">
        <div
          className="component-sub1"
          style={{ backgroundColor: "white", padding: "30px" }}
        >
          <div className="profile-container">
            {/* LEFT SIDE */}
            <div className="profile-left">
              <div className="profile-image-box">
                <img
                  src={mascot}
                  alt="profile"
                  className="profile-display-image"
                />
              </div>

              <div className="profile-basic">
                <h3>{userData.Name}</h3>
                <p className="basic-role">{userData.Designation}</p>

                <button
                  className="profile-password-btn"
                  onClick={() => setShowPasswordModal(true)}
                >
                  Change Password
                </button>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="profile-right">
              <div className="profile-field">
                <label>Name</label>
                <p>{userData.Name}</p>
              </div>

              <div className="profile-field">
                <label>Staff ID</label>
                <p>{userData.Staffid}</p>
              </div>

              <div className="profile-field">
                <label>Role</label>
                <p>{userData.Role}</p>
              </div>

              <div className="profile-field">
                <label>Designation</label>
                <p>{userData.Designation}</p>
              </div>

              <div className="profile-field">
                <label>Contact Number</label>
                <p>{userData.Contact_number}</p>
              </div>

              <div className="profile-field">
                <label>Email</label>
                <p>{userData.Email || "Not Provided"}</p>
              </div>

              <div className="profile-field">
                <label>Status</label>
                <p>{userData.Status}</p>
              </div>

              <div className="profile-field">
                <label>User Type</label>
                <p>{userData.usertype}</p>
              </div>
            </div>
          </div>

          {/* CHANGE PASSWORD MODAL */}
          <Modal
            show={showPasswordModal}
            onHide={handleClose}
            centered
            backdrop="static"
            className="profile-password-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Change Password</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="profile-field">
                <label>Old Password</label>
                <input
                  type="password"
                  name="oldPassword"
                  className="profile-input"
                  value={passwordData.oldPassword}
                  onChange={handlePasswordChange}
                />
              </div>

              <div className="profile-field">
                <label>New Password</label>
                <input
                  type="password"
                  name="newPassword"
                  className="profile-input"
                  value={passwordData.newPassword}
                  onChange={handlePasswordChange}
                />
              </div>

              <div className="profile-field">
                <label>Confirm Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  className="profile-input"
                  value={passwordData.confirmPassword}
                  onChange={handlePasswordChange}
                />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSavePassword}>
                Save Password
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </Maincomponent>
  );
}
